import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  successResponse: {},
  mytripResponse: {},
  isLoading: false,
  isTripLoading: false,
  isLifeStyleLoading: false,
  isError: false,
  error: false,
  mytripError: false,
  lifestyleGovernmentData: [],
  lifestyleGovernmentError: "",
  moreServiceGovernmentData: [],
  moreServiceGovernmentError: "",
  newsannouncementGovernmentData: [],
  newsannouncementGovernmentError: "",
  faqGovernmentData: [],
  faqGovernmentError: "",
  complementJourneyResponse: [],
  flightUpgradespenMilesResponse: [],
  newsannouncementcorporateResponse: [],
  newsannouncementagencyResponse: [],
  micecomplementJourneyResponse: []
};
const governmentBookingSlice = createSlice({
  name: "governmentBooking",
  initialState,
  reducers: {
    governmentBookingRequest: (state, action) => {
      state.isLoading = true;
      state.error = false;
      state.isError = false;
    },
    governmentBookingSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.successResponse = action.payload;
    },
    governmentBookingFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isError = true;
    },
    resetGovernmentBooking: state => {
      state.successResponse = {};
      state.isLoading = false;
      state.isError = true;
      state.error = false;
    },
    planMyTripSuccess: (state, action) => {
      state.isTripLoading = false;
      state.mytripError = false;
      state.mytripResponse = action.payload;
    },
    planMyTripFailure: (state, action) => {
      state.mytripError = action.payload;
      state.isTripLoading = false;
    },
    newsannouncementAgencySuccess: (state, action) => {
      state.isTripLoading = false;
      state.mytripError = false;
      state.newsannouncementagencyResponse = action.payload;
    },
    newsannouncementAgencyFailure: (state, action) => {
      state.mytripError = action.payload;
      state.isTripLoading = false;
    },
    lifestyleGovernmentSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.lifestyleGovernmentData = action.payload;
      state.lifestyleGovernmentError = "";
    },
    lifestyleGovernmentFailure: (state, action) => {
      state.isLifeStyleLoading = false;
      state.hasData = false;
      state.lifestyleGovernmentError = action.payload;
    },
    lifestyleGovernmentRequest: state => {
      state.isLifeStyleLoading = true;
    },
    moreServiceGovernmentSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.moreServiceGovernmentData = action.payload;
      state.moreServiceGovernmentError = "";
    },
    moreServiceGovernmentFailure: (state, action) => {
      state.isMoreServiceLoading = false;
      state.hasData = false;
      state.moreServiceGovernmentError = action.payload;
    },
    moreServiceGovernmentRequest: state => {
      state.isMoreServiceLoading = true;
    },
    newsannouncementGovernmentSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.newsannouncementGovernmentData = action.payload;
      state.newsannouncementGovernmentError = "";
    },
    newsannouncementGovernmentFailure: (state, action) => {
      state.isnewsannouncementLoading = false;
      state.hasData = false;
      state.newsannouncementGovernmentError = action.payload;
    },
    newsannouncementGovernmentRequest: state => {
      state.isnewsannouncementLoading = true;
    },
    faqGovernmentSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.faqGovernmentData = action.payload;
      state.faqGovernmentError = "";
    },
    faqGovernmentFailure: (state, action) => {
      state.isfaqLoading = false;
      state.hasData = false;
      state.faqGovernmentError = action.payload;
    },
    faqGovernmentRequest: state => {
      state.isfaqLoading = true;
    },
    complementJourneySuccess: (state, action) => {
      state.isTripLoading = false;
      state.mytripError = false;
      state.complementJourneyResponse = action.payload;
    },
    newsannouncementCorporateSuccess: (state, action) => {
      state.isTripLoading = false;
      state.mytripError = false;
      state.newsannouncementcorporateResponse = action.payload;
    },
    newsannouncementCorporateFailure: (state, action) => {
      state.mytripError = action.payload;
      state.isTripLoading = false;
    },
    complementJourneyFailure: (state, action) => {
      state.mytripError = action.payload;
      state.isTripLoading = false;
    },
    micecomplementJourneySuccess: (state, action) => {
      state.isTripLoading = false;
      state.mytripError = false;
      state.micecomplementJourneyResponse = action.payload;
    },
    micecomplementJourneyFailure: (state, action) => {
      state.mytripError = action.payload;
      state.isTripLoading = false;
    },
    flightUpgradeSpendMilessuccess: (state, action) => {
      state.isTripLoading = false;
      state.mytripError = false;
      state.flightUpgradespenMilesResponse = action.payload;
    },
    flightUpgradeSpendMilesFailure: (state, action) => {
      state.mytripError = action.payload;
      state.isTripLoading = false;
    }
  }
});
export const {
  governmentBookingRequest,
  governmentBookingSuccess,
  governmentBookingFailure,
  resetGovernmentBooking,
  planMyTripSuccess,
  planMyTripFailure,
  lifestyleGovernmentSuccess,
  lifestyleGovernmentFailure,
  lifestyleGovernmentRequest,
  moreServiceGovernmentSuccess,
  moreServiceGovernmentFailure,
  moreServiceGovernmentRequest,
  newsannouncementGovernmentSuccess,
  newsannouncementGovernmentFailure,
  newsannouncementGovernmentRequest,
  faqGovernmentSuccess,
  faqGovernmentFailure,
  faqGovernmentRequest,
  complementJourneySuccess,
  complementJourneyFailure,
  flightUpgradeSpendMilessuccess,
  flightUpgradeSpendMilesFailure,
  newsannouncementCorporateSuccess,
  newsannouncementCorporateFailure,
  newsannouncementAgencyFailure,
  newsannouncementAgencySuccess,
  micecomplementJourneySuccess,
  micecomplementJourneyFailure
} = governmentBookingSlice.actions;
export default governmentBookingSlice.reducer;